(function () {
    'use strict';

    angular.module('app.categories', [
        // Angular modules 
        'ngRoute',
        'ngFileUpload'

        // Custom modules 

        // 3rd Party Modules
        
    ]);
})();